import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userLogout } from '../utility/logout';

class VerticalNavbar extends Component {
  constructor(props){
    super(props)
    this.state={setfans:''}
    this.state={overviewclass:''}
    this.state={posttypeclass:''}
    this.state={post_interactionclass:''}
    this.state={fananalysisclass:''}
    this.state={fanpostclass:''}
    this.state={fangroupclass:''}
    this.state={loyaltyclass:''}

    this.state={setfansIcon:'inactive'}
    this.state={overviewIcon:'inactive'}
    this.state={posttypeIcon:'inactive'}
    this.state={post_interactionIcon:'inactive'}
    this.state={fananalysisIcon:'inactive'}
    this.state={fanpostIcon:'inactive'}
    this.state={fangroupIcon:'inactive'}
    this.state={loyaltyIcon:'inactive'}
  }

  logout = () =>{
    userLogout()
  }

  changeYellow(type) {
    this.props.handleTouchMap('close')
    this.setState({setfans:''})
    this.setState({overviewclass:''})
    this.setState({posttypeclass:''})
    this.setState({post_interactionclass:''})
    this.setState({fananalysisclass:''})
    this.setState({fanpostclass:''})
    this.setState({fangroupclass:''})
    this.setState({loyaltyclass:''})

    if(this.props.menuSetting == false)
    {
      this.setState({setfansIcon:'active'});
      this.setState({overviewIcon:'active'});
      this.setState({posttypeIcon:'active'});
      this.setState({post_interactionIcon:'active'});
      this.setState({fananalysisIcon:'active'});
      this.setState({fanpostIcon:'active'});
      this.setState({fangroupIcon:'active'});
      this.setState({loyaltyIcon:'active'});
    }
    else
    {
      this.setState({setfansIcon:'inactive'});
      this.setState({overviewIcon:'inactive'});
      this.setState({posttypeIcon:'inactive'});
      this.setState({post_interactionIcon:'inactive'});
      this.setState({fananalysisIcon:'inactive'});
      this.setState({fanpostIcon:'inactive'});
      this.setState({fangroupIcon:'inactive'});
      this.setState({loyaltyIcon:'inactive'});
    }

    if(type == 'setfans') 
    {
      this.setState({setfans:'yellowBkg'});
      this.setState({setfansIcon:'c'});
    }
    if(type == 'overview') 
    {
      this.setState({overviewclass:'yellowBkg'});
      this.setState({overviewIcon:'c'});
    }
    if(type == 'posttype') 
    {
      this.setState({posttypeclass:'yellowBkg'});
      this.setState({posttypeIcon:'c'});
    }
    if(type == 'post_interaction') 
    {
      this.setState({post_interactionclass:'yellowBkg'});
      this.setState({post_interactionIcon:'c'});
    }
    if(type == 'fananalysis') 
    {
      this.setState({fananalysisclass:'yellowBkg'});
      this.setState({fananalysisIcon:'c'});
    }
    if(type == 'fanpost') 
    {
      this.setState({fanpostclass:'yellowBkg'});
      this.setState({fanpostIcon:'c'});
    }
    if(type == 'fangroup') 
    {
      this.setState({fangroupclass:'yellowBkg'});
      this.setState({fangroupIcon:'c'});
    }
    if(type == 'loyalty') 
    {
      this.setState({loyaltyclass:'yellowBkg'});
      this.setState({loyaltyIcon:'c'});
    }
  }

  componentDidMount(){
    if(this.props.menuSetting == false)
    {
      this.setState({setfansIcon:'active'});
      this.setState({overviewIcon:'active'});
      this.setState({posttypeIcon:'active'});
      this.setState({post_interactionIcon:'active'});
      this.setState({fananalysisIcon:'active'});
      this.setState({fanpostIcon:'active'});
      this.setState({fangroupIcon:'active'});
      this.setState({loyaltyIcon:'active'});
    }
    else
    {
      this.setState({setfansIcon:'inactive'});
      this.setState({overviewIcon:'inactive'});
      this.setState({posttypeIcon:'inactive'});
      this.setState({post_interactionIcon:'inactive'});
      this.setState({fananalysisIcon:'inactive'});
      this.setState({fanpostIcon:'inactive'});
      this.setState({fangroupIcon:'inactive'});
      this.setState({loyaltyIcon:'inactive'});
    }
    this.setState({setfans:'yellowBkg'})
    this.setState({setfansIcon:'c'});
  }

    componentDidUpdate(prev,next){
    if(prev.menuSetting !== this.props.menuSetting)
    {
       if(this.props.menuSetting == false)
      {
        this.setState({setfansIcon:'c'});
        this.setState({overviewIcon:'active'});
        this.setState({posttypeIcon:'active'});
        this.setState({post_interactionIcon:'active'});
        this.setState({fananalysisIcon:'active'});
        this.setState({fanpostIcon:'active'});
        this.setState({fangroupIcon:'active'});
        this.setState({loyaltyIcon:'active'});
      }
      else
      {
        // this.setState({setfansIcon:'inactive'});
        this.setState({overviewIcon:'inactive'});
        this.setState({posttypeIcon:'inactive'});
        this.setState({post_interactionIcon:'inactive'});
        this.setState({fananalysisIcon:'inactive'});
        this.setState({fanpostIcon:'inactive'});
        this.setState({fangroupIcon:'inactive'});
        this.setState({loyaltyIcon:'inactive'});
      }
    }
  }


	render () {
    const { menuSetting} = this.props;
    const disabledlink = menuSetting === false ? '': 'disabled-link';
    const disabledIcon = menuSetting === false ? '': 'disabled-Icon';
    let menuOpen;
    if(this.props.openSide) {
      menuOpen = 'openMenu'
    }else {
      menuOpen = ''
    }

  	return (
        <ul className={`verticalNavbar ${menuOpen}`}>
          {/*<li className={this.state.setfans} onClick={()=>this.changeYellow('setfans')}>
            <Link to="/">
              <span className={`sprite1 sprite-icon01-${this.state.setfansIcon}`}></span>
              <div className="pageName">分析設定</div>
              <p className="tooltiptext">分析設定</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.overviewclass].join(' ')}>
            <Link to="/overview" className={disabledlink} onClick={()=>this.changeYellow('overview')}>
              <span className={`sprite1 sprite-icon02-${this.state.overviewIcon}`}></span>
              <div className="pageName">總覽</div>
              <p className="tooltiptext">總覽</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.posttypeclass].join(' ')}>
            <Link to="/posttype" className={disabledlink} onClick={()=>this.changeYellow('posttype')}>
              <span className={`sprite1 sprite-icon03-${this.state.posttypeIcon}`}></span>
              <div className="pageName">貼文熱榜</div>
              <p className="tooltiptext">貼文熱榜</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.post_interactionclass].join(' ')}>
            <Link to="/post_interaction" className={disabledlink} onClick={()=>this.changeYellow('post_interaction')}>
              <span className={`sprite1 sprite-icon04-${this.state.post_interactionIcon}`}></span>
              <div className="pageName">回應績效</div>
              <p className="tooltiptext">回應績效</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.fananalysisclass].join(' ')}>
            <Link to="/fananalysis" className={disabledlink} onClick={()=>this.changeYellow('fananalysis')}>
              <span className={`sprite1 sprite-icon05-${this.state.fananalysisIcon}`}></span>
              <div className="pageName">重疊粉絲</div>
              <p className="tooltiptext">重疊粉絲</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.fanpostclass].join(' ')}>
            <Link to="/fanpost" className={disabledlink} onClick={()=>this.changeYellow('fanpost')}>
              <span className={`sprite1 sprite-icon06-${this.state.fanpostIcon}`}></span>
              <div className="pageName">積極粉絲</div>
              <p className="tooltiptext">積極粉絲</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.fangroupclass].join(' ')}>
            <Link to="/fangroup" className={disabledlink} onClick={()=>this.changeYellow('fangroup')}>
              <span className={`sprite1 sprite-icon07-${this.state.fangroupIcon}`}></span>
              <div className="pageName">粉專互動</div>
              <p className="tooltiptext">粉專互動</p>
            </Link>
          </li>
          <li className={[disabledIcon,this.state.loyaltyclass].join(' ')}>
            <Link to="/kol" className={disabledlink} onClick={()=>this.changeYellow('loyalty')}>
              <span className={`sprite2 sprite-icon010-${this.state.loyaltyIcon}`}></span>
              <div className="pageName">KOL Ranking</div>
              <p className="tooltiptext">KOL Ranking</p>
            </Link>
          </li>*/}
          <li onClick={this.logout}>
            <span className="icon-login"></span>
            <div className="pageName">登出</div>
            <p className="tooltiptext">登出</p>
          </li>
        </ul>
    );
  }
}

function mapStateToProps({menuSetting, bgSetting}) {
  return { menuSetting, bgSetting };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerticalNavbar);


// WEBPACK FOOTER //
// ./src/components/verticalNavbar.js